module.exports = __webpack_public_path__ + "static/media/tessa-intermittent.34884736.svg";